import React from "react";
import CardTemplate from "@appsinti/ui-core/CardTemplate";
import StatsPreview from "../../../interfaces/StatsPreview";
import { CustomRow } from "../styles";
import CardTitleComponent from "../CardTitleComponent";
import { MetricData } from "@appsinti/ui-core/styles";
import { RIGHT_DARK } from "@etiquette-ui/colors";
import { formatMoney, formatMoneyMK } from "@appsinti/common-utils";

const SalesBasic: React.FC<{ preview: StatsPreview }> = ({ preview }) => {
  return (
    <CardTemplate
      background={"white"}
      noPadding={true}
      header={
        <CustomRow>
          <CardTitleComponent title={"Total Sales"} />
          <CardTitleComponent title={"Sales/Guest"} />
        </CustomRow>
      }
      body={
        <CustomRow>
          <div className="column">
            <MetricData size={"big"} weight={"bold"} color={RIGHT_DARK}>
              {formatMoneyMK(preview.total.totalSales)}
            </MetricData>
          </div>
          <div className="column">
            <MetricData size={"big"} weight={"bold"} color={RIGHT_DARK}>
              {formatMoney(preview.total.salesPerGuest, 0)}
            </MetricData>
          </div>
        </CustomRow>
      }
    />
  );
};

export default SalesBasic;
